var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 71,
    viewBox: "0 0 84 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5938 1H23.4062C14.3453 1 7 8.34533 7 17.4062V54.5938C7 63.6547 14.3453 71 23.4062 71H60.5938C69.6547 71 77 63.6547 77 54.5938V17.4062C77 8.34533 69.6547 1 60.5938 1Z",
    fill: "#242938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0003 41.1818C44.8178 41.1818 47.1015 38.8978 47.1015 36.0805C47.1015 33.2633 44.8178 30.9793 42.0003 30.9793C39.1831 30.9793 36.899 33.2633 36.899 36.0805C36.899 38.8978 39.1831 41.1818 42.0003 41.1818Z",
    fill: "#00D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0005 25.7086C48.8496 25.7086 55.2122 26.6913 60.0097 28.3432C65.7899 30.333 69.3438 33.3493 69.3438 36.0806C69.3438 38.9268 65.5774 42.1312 59.3701 44.1878C54.6774 45.7425 48.5021 46.5541 42.0005 46.5541C35.3347 46.5541 29.0224 45.7923 24.2766 44.1705C18.2725 42.1184 14.6562 38.8727 14.6562 36.0806C14.6562 33.3714 18.0496 30.3784 23.7486 28.3916C28.5638 26.7127 35.0834 25.7086 41.9995 25.7086H42.0005Z",
    stroke: "#00D8FF",
    strokeWidth: 1.54394
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9713 30.9244C36.3931 24.9914 40.4228 19.9705 44.2504 16.6401C48.8616 12.6268 53.2503 11.0551 55.6161 12.4193C58.0817 13.8412 58.9761 18.7051 57.6567 25.1095C56.6601 29.9513 54.2773 35.706 51.0292 41.3383C47.699 47.1128 43.8859 52.2003 40.1105 55.5002C35.3333 59.6761 30.7147 61.1874 28.2961 59.7926C25.9492 58.4402 25.0518 54.0048 26.1778 48.0753C27.1291 43.0651 29.5165 36.9157 32.9703 30.9244H32.9713Z",
    stroke: "#00D8FF",
    strokeWidth: 1.54394
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9798 41.3533C29.5485 35.4268 27.2122 29.4271 26.2371 24.4478C25.0633 18.4483 25.8931 13.8613 28.257 12.4931C30.7204 11.0668 35.3806 12.7211 40.2702 17.0628C43.9671 20.3451 47.7632 25.2826 51.0207 30.9094C54.3604 36.6783 56.8635 42.5231 57.8372 47.4417C59.0693 53.6662 58.0721 58.4221 55.6557 59.8207C53.3113 61.1781 49.0208 59.7412 44.4459 55.8042C40.5806 52.4781 36.4451 47.3388 32.9798 41.3533Z",
    stroke: "#00D8FF",
    strokeWidth: 1.54394
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(7 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosReact);
export default __webpack_public_path__ + "static/media/logos_react.f3ca156be5e90919eab332a9a12f2931.svg";
export { ForwardRef as ReactComponent };